export const getAllSquadsUnfiltered = () => {
  return `
        SELECT 
            id,
            Name, Lider__c,
            Imagem_da_mesa__c,
            Lider__r.Time__c,
            Lider__r.Nome_do_Outlook__c,
            Lider__r.Email_do_Salesforce__c,
            Lider__r.Name,
            Lider__r.Name__c,
            Department__c,
            Planning_Department__c,
            Canal__c
        FROM
            Mesa__c
        ORDER by Name ASC
      `;
};
